import "./layout.css";

import Footer from "./Footer.js";
import Header from "./header";
import PageTile from "../layout/PageTile";
import PropTypes from "prop-types";
import React from "react";
import { StaticQuery, graphql } from "gatsby";

import { makeStyles } from "@material-ui/core/styles";

const FOOTER_HEIGHT = "4rem";

const useStyles = makeStyles(() => ({
    pageContainer: {
        position: "relative",
        minHeight: "100vh"
    }
}));

const Layout = ({ children }) => {
    const classes = useStyles();
    return (
        <StaticQuery
            query={graphql`
                query SiteTitleQuery {
                    site {
                        siteMetadata {
                            title
                        }
                    }
                }
            `}
            render={data => (
                <>
                    <div id="pageContainer" className={classes.pageContainer}>
                        <PageTile verticalPadding={2}>
                            <Header siteTitle={data.site.siteMetadata.title} />
                        </PageTile>
                        <div>{children}</div>
                    </div>
                    <Footer />
                </>
            )}
        />
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired
};

export default Layout;
